import React from "react";
import "./Home.css";
import PhoneMockups from "../../components/PhoneMockups/PhoneMockups";
import Footer from "../../components/Footer/Footer";

export default function Home({ navigate, showComingSoon }) {
  const handleDownload = (e) => {
    e.preventDefault();
    showComingSoon();
  };

  return (
    <>
      {/* ─── HERO ────────────────────────────────────── */}
      <section className="hero">
        <div className="hero-badge anim-badge">
          <span></span> Coming Soon on iOS &amp; Android
        </div>

        <h1 className="hero-title anim-title">
          Your AI
          <br />
          <em>Co-Pilot</em>
          <br />
          on Every Road
        </h1>

        <p className="hero-sub anim-sub">
          RoadDogg AI puts a smart AI assistant, live maps, activity logs, and
          real-time weather right in your pocket — for everyone who moves.
        </p>

        <div className="hero-ctas anim-ctas">
          <a href="#" className="btn-primary" onClick={handleDownload}>
            <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
              <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.8-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z" />
            </svg>
            App Store
          </a>
          <a href="#" className="btn-secondary" onClick={handleDownload}>
            <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
              <path d="M3.18 23.76c.3.17.64.22.97.16l12.09-6.98-2.56-2.55-10.5 9.37zM20.65 9.29L17.3 7.35 14.43 10l3.03 3.03 3.21-1.85c.91-.52.91-1.95-.02-2.89zM2.25.14C1.96.42 1.78.86 1.78 1.43v21.09c0 .58.18 1.01.48 1.28l.07.06 11.81-11.81v-.28L2.32.08 2.25.14zM3.18.19l12.09 6.98-2.56 2.55L2.21.35c.3-.17.64-.22.97-.16z" />
            </svg>
            Google Play
          </a>
        </div>

        {/* Three animated phone mockups */}
        <PhoneMockups />
      </section>

      {/* ─── FEATURE STRIP ───────────────────────────── */}
      <div className="features-strip">
        <div className="strip-inner">
          <div className="strip-item">AI Voice Assistant</div>
          <div className="strip-dot"></div>
          <div className="strip-item">Smart Maps</div>
          <div className="strip-dot"></div>
          <div className="strip-item">Activity &amp; Expense Logs</div>
          <div className="strip-dot"></div>
          <div className="strip-item">Real-Time Weather</div>
          <div className="strip-dot"></div>
          <div className="strip-item">App Lock Security</div>
          <div className="strip-dot"></div>
          <div className="strip-item">iOS &amp; Android</div>
        </div>
      </div>

      {/* ─── FEATURES GRID ───────────────────────────── */}
      <div className="features-wrap">
        <div className="section">
          <div className="section-label">What's Inside</div>
          <h2 className="section-title">
            Every tool you need,
            <br />
            zero distractions.
          </h2>
          <p className="section-sub">
            Six purpose-built features designed around the real demands of life
            on the move — whether you commute daily, travel often, or work on
            the road.
          </p>

          <div className="features-grid">
            <div className="feat-card">
              <div className="feat-icon-wrap" style={{ background: "#F3F0FF" }}>
                🤖
              </div>
              <h3>AI Avatar Assistant</h3>
              <p>
                Converse with a live, animated AI companion. Ask about routes,
                weather, nearby places, or anything else — voice-first,
                hands-free, and always ready when you need it.
              </p>
            </div>
            <div className="feat-card">
              <div className="feat-icon-wrap" style={{ background: "#EBF3FF" }}>
                🗺️
              </div>
              <h3>Intelligent Maps</h3>
              <p>
                Google Maps with smart quick filters: Gas Stations, Food, Rest
                Stops, and Parking — one tap away. Context-aware pins surface
                exactly what you need, exactly when you need it.
              </p>
            </div>
            <div className="feat-card">
              <div className="feat-icon-wrap" style={{ background: "#FFF3E8" }}>
                📋
              </div>
              <h3>Smart Logs &amp; File Cabinet</h3>
              <p>
                Activity records, expenses, maintenance notes, receipts, and
                important documents — all organized in one searchable digital
                cabinet. Access everything instantly, no paper required.
              </p>
            </div>
            <div className="feat-card">
              <div className="feat-icon-wrap" style={{ background: "#ECFDF5" }}>
                🌤️
              </div>
              <h3>Real-Time Weather</h3>
              <p>
                Live weather conditions and radar for any location, any time.
                Stay ahead of the forecast before and during every journey —
                surfaced automatically by the AI assistant.
              </p>
            </div>
            <div className="feat-card">
              <div className="feat-icon-wrap" style={{ background: "#FFF0F0" }}>
                🔒
              </div>
              <h3>Privacy &amp; App Lock</h3>
              <p>
                A built-in security lock screen protects your conversations,
                location history, and records. Your data stays yours — always
                encrypted, never sold to anyone.
              </p>
            </div>
            <div className="feat-card">
              <div className="feat-icon-wrap" style={{ background: "#F0FFF4" }}>
                ⚡
              </div>
              <h3>Cloud-Powered &amp; Always Fresh</h3>
              <p>
                A smart backend means the app improves continuously — smarter
                AI, better responses, faster performance. Updates roll out
                automatically, no manual installs needed.
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* ─── LOGS / FILE CABINET DETAIL ──────────────── */}
      <div className="logs-wrap">
        <div className="logs-inner">
          {/* Left: copy */}
          <div>
            <div className="section-label">File Cabinet</div>
            <h2 className="section-title">Every record. One place.</h2>
            <p
              style={{
                fontSize: "17px",
                color: "var(--text-muted)",
                lineHeight: 1.7,
                marginBottom: "32px",
              }}
            >
              Expenses, activity history, service records, receipts, and
              important documents — everything lives in a searchable, organized
              digital cabinet. Ask the AI to pull anything up on command.
            </p>

            {[
              {
                color: "#F97316",
                label: "Expense Log — Costs, categories, and spending history",
              },
              {
                color: "#3B82F6",
                label: "Activity Log — Destinations, routes, and journey notes",
              },
              {
                color: "#EF4444",
                label: "Maintenance — Service history, repairs, reminders",
              },
              {
                color: "#22C55E",
                label: "Receipts — Gas, food, tolls, and general expenses",
              },
              {
                color: "#3B82F6",
                label: "Documents — Registrations, insurance, permits",
              },
              {
                color: "#22C55E",
                label: "Notes — Personal logs, voice memos, reminders",
              },
            ].map((item, i) => (
              <div key={i} className="log-bullet">
                <span
                  className="log-bullet-dot"
                  style={{ background: item.color }}
                />
                {item.label}
              </div>
            ))}
          </div>

          {/* Right: visual card */}
          <div className="logs-visual">
            <div className="log-header-card">
              <div className="log-hc-top">
                <div>
                  <div className="log-hc-title">File Cabinet</div>
                  <div className="log-hc-sub">Your personal records</div>
                </div>
              </div>
              <div className="log-stats">
                <div className="log-stat">
                  <div className="n">8</div>
                  <div className="l">Folders</div>
                </div>
                <div className="log-stat">
                  <div className="n">4</div>
                  <div className="l">Items</div>
                </div>
                <div className="log-stat">
                  <div className="n">3</div>
                  <div className="l">Recent</div>
                </div>
              </div>
            </div>

            {[
              {
                icon: "💰",
                bg: "#FFF3E8",
                title: "Expense Log",
                sub: "Costs, categories, and spending history",
                badgeBg: "#FFF3E8",
                badgeColor: "#C2410C",
                label: "1 entry",
              },
              {
                icon: "📍",
                bg: "#EBF3FF",
                title: "Activity Log",
                sub: "Destinations, routes, and journey notes",
                badgeBg: "#EBF3FF",
                badgeColor: "#1D4ED8",
                label: "1 entry",
              },
              {
                icon: "🔧",
                bg: "#FFF0F0",
                title: "Maintenance",
                sub: "Service history, repairs, and reminders",
                badgeBg: "#FFF0F0",
                badgeColor: "#B91C1C",
                label: "1 entry",
              },
              {
                icon: "📄",
                bg: "#ECFDF5",
                title: "Receipt Folder",
                sub: "Gas, food, tolls, and general expenses",
                badgeBg: "#ECFDF5",
                badgeColor: "#15803D",
                label: "1 entry",
              },
            ].map((item, i) => (
              <div key={i} className="log-item">
                <div className="log-item-icon" style={{ background: item.bg }}>
                  {item.icon}
                </div>
                <div className="log-item-text">
                  <div className="t">{item.title}</div>
                  <div className="s">{item.sub}</div>
                </div>
                <div
                  className="log-badge"
                  style={{ background: item.badgeBg, color: item.badgeColor }}
                >
                  {item.label}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* ─── DOWNLOAD CTA ────────────────────────────── */}
      <div className="download-cta">
        <h2>Hit the road smarter.</h2>
        <p>Free to download. Premium features available for power users.</p>
        <div className="dl-btns">
          <a href="#" className="app-store-btn">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
              <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.8-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z" />
            </svg>
            <span className="asb-text">
              <span className="small">Coming Soon</span>
              <span className="big">App Store</span>
            </span>
          </a>
          <a href="#" className="app-store-btn">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
              <path d="M3.18 23.76c.3.17.64.22.97.16l12.09-6.98-2.56-2.55-10.5 9.37zM20.65 9.29L17.3 7.35 14.43 10l3.03 3.03 3.21-1.85c.91-.52.91-1.95-.02-2.89zM2.25.14C1.96.42 1.78.86 1.78 1.43v21.09c0 .58.18 1.01.48 1.28l.07.06 11.81-11.81v-.28L2.32.08 2.25.14zM3.18.19l12.09 6.98-2.56 2.55L2.21.35c.3-.17.64-.22.97-.16z" />
            </svg>
            <span className="asb-text">
              <span className="small">Coming Soon</span>
              <span className="big">Google Play</span>
            </span>
          </a>
        </div>
      </div>

      <Footer navigate={navigate} showComingSoon={showComingSoon} />
    </>
  );
}
